import axios from '@/axios'


const state = {
  loadingDepositPercentages:false,
  loadingDepositAmount:false,
  loadingDepositAmountIp:false,
  loadingDepositAmountCity:false,
  loadingDepositAmountIpCity:false,
  loadingDepositAmountAdv:false,
  loadingDepositAmountCa:false,
  loadingDepositAmountIpCollection:false,
  loadingDepositAmountSort:false,
  loadingDepositAmountReturned:false,
};
const actions = {
  async DepositPercentages({commit}, payload) {
    try {
      commit('LOADING_Deposit_Percentages', true);
      const {data} = await axios.post('admin/transaction/query/charity',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Percentages', false);
    }
  },
  async DepositAmount({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount', true);
      const {data} = await axios.post('admin/transaction/query/charity/date',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount', false);
    }
  },
  async DepositAmountIp({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_IP', true);
      const {data} = await axios.post('admin/transaction/query/charity/all',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_IP', false);
    }
  },
  async DepositAmountCity({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_CITY', true);
      const {data} = await axios.post('admin/transaction/chart/city',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_CITY', false);
    }
  },
  async DepositAmountIpCity({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_IP_CITY', true);
      const {data} = await axios.post('admin/transaction/chart/ip/city',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_IP_CITY', false);
    }
  },
  async DepositAmountAdv({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_ADV', true);
      const {data} = await axios.post('admin/transaction/chart/adv',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_ADV', false);
    }
  },
  async DepositAmountCa({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_CA', true);
      const {data} = await axios.post('admin/transaction/chart/ip/ca',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_CA', false);
    }
  },
  async DepositAmountIpCollection({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_IP_COLLECTION', true);
      const {data} = await axios.post('admin/transaction/chart/ip/collection',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_IP_COLLECTION', false);
    }
  },
  async DepositAmountSort({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_SORT', true);
      const {data} = await axios.post('admin/transaction/ip/payment',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_SORT', false);
    }
  },
  async DepositAmountReturned({commit}, payload) {
    try {
      commit('LOADING_Deposit_Amount_RETUNED', true);
      const {data} = await axios.post('admin/transaction/ip/refund',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Deposit_Amount_RETUNED', false);
    }
  },

};
const mutations = {
  LOADING_Deposit_Percentages(state,payload){
    state.loadingDepositPercentages = payload;
  },
  LOADING_Deposit_Amount(state,payload){
    state.loadingDepositAmount = payload;
  },
  LOADING_Deposit_Amount_IP(state,payload){
    state.loadingDepositAmountIp = payload;
  },
  LOADING_Deposit_Amount_CITY(state,payload){
    state.loadingDepositAmountCity = payload;
  },
  LOADING_Deposit_Amount_IP_CITY(state,payload){
    state.loadingDepositAmountIpCity = payload;
  },
  LOADING_Deposit_Amount_ADV(state,payload){
    state.loadingDepositAmountAdv = payload;
  },
  LOADING_Deposit_Amount_CA(state,payload){
    state.loadingDepositAmountCa = payload;
  },
  LOADING_Deposit_Amount_IP_COLLECTION(state,payload){
    state.loadingDepositAmountIpCollection = payload;
  },
  LOADING_Deposit_Amount_SORT(state,payload){
    state.loadingDepositAmountSort = payload;
  },
  LOADING_Deposit_Amount_RETUNED(state,payload){
    state.loadingDepositAmountReturned = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
